/**
 * Shared Zod schemas for the onboarding wizard.
 *
 * Lives in /lib/ so both the step components (which validate locally
 * via `useZodForm`) AND the parent orchestrator (`Onboarding.jsx`,
 * which gates `Next` clicks) can import the SAME contract. Without a
 * shared module the two would drift: someone could relax `full_name`
 * in the step but the parent's safeParse keeps blocking — confusing.
 *
 * Currently only ``Step1ProfileSchema`` is migrated. Other steps still
 * use ad-hoc validators inside `Onboarding.jsx`; they'll migrate as
 * each step is touched.
 */
import { z } from "zod";

export const Step1ProfileSchema = z.object({
  // Trim then require ≥1 char so " " alone doesn't slip through.
  full_name: z.string().trim().min(1),
  // Optional fields — defaulted in `initialState`. We keep them in the
  // schema so the typing of values is complete and so future strictness
  // (e.g. require currency) can be enabled without churning every form
  // call-site.
  professional_activity: z.string().optional(),
  currency: z.string().optional(),
  // Accept either string or number; the parent coerces to Number before
  // POSTing. We don't validate > 0 yet because legit freelancers DO
  // sometimes hit zero in the worst months and lying just to pass the
  // form is bad onboarding UX.
  avg_monthly_income: z.union([z.string(), z.number()]).optional(),
});
